<script lang="ts">
    import { Col, ListGroup, ListGroupItem } from "sveltestrap";
    import { Crasjustoodio, Dapibusacfacilisisin, Morbileorisus, Vestibulumateros, WithIcon} from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" xl="12">
    <Card cardHeaderprops="pb-0" headerTitle={WithIcon}>
      <div slot="contentbody">
        <ListGroup>
          <ListGroupItem >
            <i class="icon-save-alt"></i>{Crasjustoodio}
          </ListGroupItem>
          <ListGroupItem >
            <i class="icon-target"></i>{Dapibusacfacilisisin}
          </ListGroupItem>
          <ListGroupItem >
            <i class="icon-mobile"></i>{Morbileorisus}
          </ListGroupItem>
          <ListGroupItem disabled>
            <i class="icon-shopping-cart-full"></i>{Vestibulumateros}
          </ListGroupItem>
        </ListGroup>
      </div>
    </Card>
</Col>
